var _rect, _rect2, _rect3, _g, _ellipse, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup74(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 89,
    viewBox: "0 0 86 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 28.4963,
    y: 27.5671,
    width: 56.9928,
    height: 60.7098,
    rx: 8,
    fill: "url(#paint0_linear_179_171)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 56.9928,
    height: 60.7098,
    rx: 8,
    fill: "url(#paint1_linear_179_171)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_179_171",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 29,
    y: 27,
    width: 58,
    height: 62
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 29.0078,
    y: 27.7444,
    width: 56.9928,
    height: 60.7098,
    rx: 8,
    fill: "url(#paint2_linear_179_171)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_179_171)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.511719,
    y: 0.177246,
    width: 56.9928,
    height: 60.7098,
    rx: 8,
    fill: "#3646DA"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 42.746,
    cy: 45.8422,
    rx: 7.74359,
    ry: 7.74359,
    fill: "url(#paint3_linear_179_171)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_179_171",
    x1: 74.9579,
    y1: 44.9128,
    x2: 34.0717,
    y2: 83.321,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3646DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#528EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_179_171",
    x1: 28.4964,
    y1: 0,
    x2: 28.4964,
    y2: 60.7098,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#528EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7714E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_179_171",
    x1: 75.4694,
    y1: 45.09,
    x2: 34.5832,
    y2: 83.4983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#484848"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#7B7B7B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_179_171",
    x1: 42.746,
    y1: 38.0986,
    x2: 42.746,
    y2: 53.5858,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9CBDD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup74);
export default __webpack_public_path__ + "static/media/Group 74.4e815524c2e68bc44e6400f713d65a19.svg";
export { ForwardRef as ReactComponent };